// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-custom button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.games {
  padding: 16px 0;
  font-family: Arial, Helvetica, sans-serif;
  width: 100%;
}

.game {
  text-transform: uppercase;
  padding-block: 4px;
}
.game:nth-child(2n) {
  background-color: #eaf6ff;
}
.gameTitle {
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  gap: 40px;
}

.gameDescription {
  text-transform: uppercase;
}

.startDate {
  white-space: nowrap;
}

.price {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  text-transform: uppercase;
  padding: 8px 0;
  border-bottom: 3px double black;
}
.text {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/results/CheckTicket.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;EACd,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".button-custom button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.games {\n  padding: 16px 0;\n  font-family: Arial, Helvetica, sans-serif;\n  width: 100%;\n}\n\n.game {\n  text-transform: uppercase;\n  padding-block: 4px;\n}\n.game:nth-child(2n) {\n  background-color: #eaf6ff;\n}\n.gameTitle {\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  gap: 40px;\n}\n\n.gameDescription {\n  text-transform: uppercase;\n}\n\n.startDate {\n  white-space: nowrap;\n}\n\n.price {\n  display: flex;\n  justify-content: space-between;\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 8px 0;\n  border-bottom: 3px double black;\n}\n.text {\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
